import {
  ROOT,
  GET_ALL_PLAN,
  GET_ALL_MEAL,
  GET_PLAN_DETAIL,
  DELETE_PLAN,
  CREATE_PLAN,
  UPDATE_PLAN,
  DUPLICATE_PLAN,
  UPDATE_SALE_PACKAGE_STATUS,
  GET_PAYMENT_POLICY,
  GET_CANCEL_POLICY,
  GET_APPLY_CARD_TYPE,
  GET_APPLY_FOR_OBJECT,
  CHECK_DUPLICATE_SALE_PACKAGE_CODE,
  GET_ROOM_RATE,
  SORT_INDEX_PLAN,
  GET_ALL_EZ_PROMOTION
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

//#region list of rooms
function getPromotion(data) {
  return fetch(ROOT + GET_ALL_EZ_PROMOTION, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllPlan(data) {
  return fetch(ROOT + GET_ALL_PLAN, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getRoomRate(data) {
  return fetch(ROOT + GET_ROOM_RATE + `/${data}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function validateSalePackageCode(data) {
  return fetch(ROOT + CHECK_DUPLICATE_SALE_PACKAGE_CODE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}


function getPaymentPolicy(params) {
  return fetch(
    ROOT +
    GET_PAYMENT_POLICY +
    `?limit=${params.limit}&offset=${params.offset}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getApplyCardType() {
  return fetch(ROOT + GET_APPLY_CARD_TYPE, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getApplyForObject() {
  return fetch(ROOT + GET_APPLY_FOR_OBJECT, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getCancelPolicy(params) {
  return fetch(
    ROOT +
    GET_CANCEL_POLICY +
    `?limit=${params.limit}&offset=${params.offset}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getMeal() {
  return fetch(ROOT + GET_ALL_MEAL, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateSalePackageStatus(data) {
  return fetch(ROOT + UPDATE_SALE_PACKAGE_STATUS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getDetail(id) {
  return fetch(ROOT + GET_PLAN_DETAIL + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function create(data) {
  return fetch(ROOT + CREATE_PLAN, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function update(data) {
  return fetch(ROOT + UPDATE_PLAN, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function duplicate(data) {
  return fetch(ROOT + DUPLICATE_PLAN, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function remove(id) {
  return fetch(ROOT + DELETE_PLAN + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}


function sortIndexPlan(data) {
  return fetch(ROOT + SORT_INDEX_PLAN, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
//#endregion
export const salePackageService = {
  getPromotion,
  validateSalePackageCode,
  getApplyForObject,
  getCancelPolicy,
  getApplyCardType,
  getPaymentPolicy,
  getMeal,
  updateSalePackageStatus,
  getAllPlan,
  getDetail,
  create,
  update,
  remove,
  duplicate,
  getRoomRate,
  sortIndexPlan
};
